import { FormikProps } from 'formik';
import { ReactNode } from 'react';
import { IFormFieldConfig } from '@shared/components/FormFieldsConstructor';
import { IFinanceConditionItem, IFinanceDetails } from '../../interfaces';

export interface IComment {
  id: string;
  contactId: string;
  lenderCode: string;
  dealId: string;
  comment: string;
  isLenderComment: boolean;
  createdBy: string;
  createdDate: string;
}

export interface ICommentRequest {
  contactId: string;
  lenderCode: string;
  dealId: string;
  comment: string;
  isLenderComment: boolean;
}

export interface IFinanceModalProps {
  financeModalPostition: number;
  assetId: string;
  handleClose: () => void;
  financeConditionItem?: IFinanceConditionItem
}

export interface IPayoffQuote {
  payoffAmount: number | null;
  payoffPerDiem: number | null;
  payoffGoodDate: Date;
  totalPayoffAmount: number | null;
  dtTransactionFee: number | null;
  dtTaxes: number | null;
  dtTotalDue: number | null;
  // dtRefundDue: number | null;
  payoffQuoteId?: string | null;
  totalAdjustment: number | null;
  customerRefundAmount?: number;
  adjustmentThreshold?: string;
  atTitleIsReleasable?: boolean;
  dealId?: string;
}

export interface IAddAdjustment {
  amountToFinanceFlat?: number;
  adjustedPayoff?: number;
  totalAdjustment: number | null;
}

export interface IFinanceFormProps {
  formTitle: string;
  formProps: FormikProps<IFinanceData>;
  formConfig: IFormFieldConfig[];
  holidays?: string[];
  buttonText: string;
  disableSubmitButton?: boolean;
  buttonWidth?: string;
  firstCustomButtonText?: string;
  secondCustomButtonText?: string;
  cancelButtonText?: string;
  handleAddAdjustment?: (data: IAddAdjustment) => void;
  handleFirstButtonClick?: () => void;
  handleSecondButtonClick?: () => void;
  handleCancelClick?: () => void;
  salesPrice: number | string | null;
}

export interface ISubmitPayOffQuoteResponse {
  payoffSubmissionId: string;
}

export enum EConfirmationModalText {
  SubmitPayoffConfirmation = 'Are you sure, you want to submit Payoff to DealerTrack?',
  RemoveDealFromAT = 'Do you want to remove this deal from the Accelerated Title Process?',
  CancelPayOffConfirmation = 'Are you sure, you want to cancel Payoff to DealerTrack?'
}
export interface ICancelPayOffQuoteResponse {
  succeed: boolean;
}

export interface ViewXmlModalProps {
  onClose: (() => void) | undefined;
  data?: IFinanceDetails;
  viewXmlModalPosition: number;
}

export enum LenderResponseDisplayTypes {
  Html,
  Xml,
  Pdf,
  Json
}

export interface IFinanceData {
  adjustments: IAddAdjustment;
  payOffData: IPayoffQuote;
}

export interface ICalculatorFormProps {
  formConfig: IFormFieldConfig[];
  children: ReactNode;
}

export interface IntrestRateCalc {
  amountFinanced: number | null;
  term: number | null;
  paymentAmount: number | null;
}

export interface IAmorizationDetailer {
  amortFinanced: number | null;
  amortTerm: number | null;
  amortApr: number | null;
  amortExtra?: number | null;
}

export interface IAmortSchedules {
  month: number | null;
  payment: number | null;
  principal: number | null;
  interest: number | null;
  additionalPrincipal: number | null;
  balance: number | null;
}

export interface IAmorizationDetailerResponse {
  totalInterest: number | null
  totalInterestPaid: number | null;
  effectiveTerm: number | null;
  amortSchedules: []
}

export interface ICalculator {
  onClose: () => void;
  calculatorModalPosition?: number;
}

export interface IAssetReports {
  condition: string;
  EXP?: string | number;
  TU?: string | number;
  EQ?: string | number;
}

export interface IAssetMatchingRecords {
  bureau: string;
  leinHolder?: number | null;
  rate?: number | null;
  payment?: number | null;
  balance?: number | null;
  accountNumber?: number | null;
  assetOnReport?: string | null;
  confidenceScore?: number | null;
}

export interface IAssetOnReportsResponse {
  searchResults: BureauSearchResult[];
  contactId: string;
}

export interface BureauSearchResult {
  bureauType: string;
  autoTradeLines: AutoTradeLine[];
  matchingRecords: MatchingRecord[];
}

export interface AutoTradeLine {
  index: number;
  accountNumber: string;
  creditorName: string;
  originalAmount: number;
  term: number;
  balance: number;
  payment: number;
  monthsRemaining: number;
  status: string;
  estApr: number;
  coSigner: string;
  openDate: string;
}

export interface MatchingRecord {
  overallScore: number;
  record: AutoTradeLine;
  fieldScoreDetails: FieldScoreDetail[];
}

interface FieldScoreDetail {
  fieldName: string;
  searchValue: number | string;
  matchingScore: number;
}

export interface IAssetOnReports {
  assetId: string;
  onClose: () => void;
}